interface JsonLdProps {
  data: object;
}

/** Renders JSON-LD structured data as a script tag for SEO */
export function JsonLd({ data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
